<template>
  <div>
    <el-form label-width="140px" :model="datas" ref="form" :validOnChange="true" :rules="validationRules">
      <el-form-item label="父节点" prop="pid">
<!--        <treePicker :treePicker="treePicker" style="width: 80%"></treePicker>-->
      </el-form-item>
      <el-form-item label="名称" prop="name" class="line-height">
        <el-input size="" type="text" v-model="datas.name" style="width: 80%" />
      </el-form-item>
      <el-form-item label="标识" prop="url" class="line-height">
        <el-input size="" type="text" v-model="datas.url" style="width: 80%" />
      </el-form-item>
      <el-form-item label="图标(icon)">
        <div class="menu-add" style="width: 80%">
          <span @click="openIcon = true" class="menu-icon">
            <em :class="datas.icon" class="icon-info"></em>
          </span>
          <el-input class="menu-input" type="text" v-model="datas.icon" placeholder="点击左侧选择图标" readonly @click="openIcon = true" />
          <span v-show="datas.icon" @click="datas.icon = ''" class="menu-show">
            <em class="el-icon-delete" style="color: #fff"></em>
          </span>
        </div>
      </el-form-item>
      <el-form-item label="排序" class="line-height-special">
        <el-input-number v-model="datas.orderNum" :min="1" style="width: 80%"></el-input-number>
      </el-form-item>
      <el-form-item label="打开方式" prop="target" class="line-height">
        <el-radio-group v-model="datas.target" style="width: 80%">
          <el-radio v-for="item in blankAry" :key="item.key" :label="item.title"></el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="状态" prop="enable" class="line-height">
        <el-radio-group v-model="datas.enable" style="width: 80%">
          <el-radio v-for="item in Ary" :key="item.key" :label="item.key">{{ item.title }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="添加为按钮" prop="enable" class="line-height">
        <el-checkbox v-model="checked" @change="addButton">按钮</el-checkbox>
      </el-form-item>
      <div style="display: flex; justify-content: center">
        <el-button style="width: 150px" type="primary" @click="save()" size="mini">提交</el-button>
        <el-button style="width: 150px; margin-left: 20px" type="danger" @click="close()" size="mini">关闭</el-button>
      </div>
    </el-form>
    <el-dialog v-dialogDrag title="icon列表" :close-on-click-modal="false" :visible.sync="openIcon" width="900px" :modal="false">
      <Icon @close="close" @success="success"></Icon>
    </el-dialog>
  </div>
</template>
<script>
import Icon from './icon';
export default {
  components: {
    Icon,
  },
  props: {
    params: Object
  },
  computed: {
    treePick() {
      return this.$store.state.employee.treePick;
    }
  },
  watch: {
    treePick(old) {
      this.datas.pid = old;
    }
  },
  data() {
    return {
      validationRules: {
        pid: [{ required: true, message: '请选择父节点', trigger: 'blur' }],
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }]
      },
      blankAry: [
        { key: '_blank', title: '_blank' },
        { key: '_top', title: '_top' },
        { key: '_self', title: '_self' },
        { key: '_parent', title: '_parent' }
      ],
      openIcon: false,
      datas: {
        pid: null,
        orderNum: null,
        enable: 'TRUE',
        target: '_blank',
        url: null,
        name: null,
        menuType: '',
        menuCode: ''
      },
      Ary: [
        { key: 'TRUE', title: '显示' },
        { key: 'FALSE', title: '隐藏' }
      ],
      param: {
        keyName: 'id',
        parentName: 'pid',
        titleName: 'name',
        dataMode: 'tree',
        datas: ''
      },
      checked: false,
      treePicker: {
        url: `${$api_eap.menu.tree}`,
        params: {},
        toLabel: 'name'
      }
    };
  },
  mounted() {
    // 根据id获取商品数据
    if (this.params.id != null) {
      this.leftForById();
    }
    this.$store.dispatch('changeNodeName', this.params.teamName);
    this.$store.dispatch('changeTreePick', this.params.teamId);
  },
  methods: {
    // 新增权限按钮
    addButton() {
      if (this.datas.menuType === '') {
        this.datas.menuType = 'button';
        this.datas.menuCode = this.datas.url;
      } else {
        this.datas.menuType = '';
      }
    },
    close() {
      this.$emit('close');
    },
    success(data) {
      this.openIcon = false;
      this.datas.icon = data.icon;
    },
    change(value) {
      let par = value.children;
      if (par === '' || par === null || par === undefined) {
        this.datas.orderNum = 1;
      } else {
        this.datas.orderNum = par.length + 1;
      }
    },
    async save() {
      if (this.datas.pid === null) {
        this.$message.error('请选择父节点');
        return;
      }
      let res = await this.$refs.form.validate();
      if (!res) {
        return;
      }
      // ('保存中，请稍后');
      if (this.datas.menuType) {
        if (!this.datas.menuCode) {
          this.$message.error('新增权限按钮，请填写标识');
          return false;
        }
      }
      httpKit.post($api_eap.menu.save, this.datas).then(res => {
        if (res.data.code === '200') {
          this.$message.success(res.data.msg);
          // .close();
          this.$emit('success');
        } else {
          this.$message.error(res.data.msg);
          this.$emit('close');
        }
      });
    },
    leftForById() {
      let par = { menuId: this.params.id };
      httpKit.post($api_eap.menu.info, par).then(res => {
        if (res.data.code === '200') {
          this.datas = res.data.data;
          let obj = findInTree(this.params.tree, this.datas.pid, 'id');
          this.$store.dispatch('changeNodeName', obj.label);
          this.$store.dispatch('changeTreePick', this.datas.pid);
        }
      });
    },
    tree() {
      httpKit.post($api_eap.menu.tree).then(res => {
        if (res.data.code === '200') {
          if (res.data.data.length > 0) {
            this.param.datas = res.data.data;
          }
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.el-form-item {
  margin-bottom: 20px;
}
.menu-add {
  display: flex;
}
.menu-icon {
  display: inline-block;
  width: 40px;
  line-height: 38px;
  text-align: center;
  background: rgb(240, 246, 255);
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  .icon-info {
    color: #999;
    font-size: 18px;
    cursor: pointer;
    transition: 0.3s;
  }
}
.menu-icon:hover .icon-info {
  color: #409eff;
}
.menu-input {
  width: calc(100% - 40px);
  .el-input {
    .el-input__inner {
      border-radius: 0 !important;
    }
  }
}
.menu-input .el-input {
  width: 318px;
  border-radius: 0;
}
.menu-show {
  display: inline-block;
  width: 40px;
  line-height: 40px;
  text-align: center;
  background-color: #f1556c;
  border-radius: 4px;
}
.line-height /deep/ .el-form-item__label {
  line-height: 40px !important;
}
.line-height-special /deep/ .el-form-item__label {
  line-height: 46px !important;
}
</style>
